import { render } from "./ImportUploadStep.vue?vue&type=template&id=4a8fe1a5"
import script from "./ImportUploadStep.vue?vue&type=script&lang=js"
export * from "./ImportUploadStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__